'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Component = require('./Component');

var _Component2 = _interopRequireDefault(_Component);

var _reactisForms = require('reactis-forms');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Glyphicon = require('./Glyphicon');

var _Glyphicon2 = _interopRequireDefault(_Glyphicon);

var _components = {
	_$Select: {
		displayName: 'Select'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Select = (function (_React$Component) {
	_inherits(Select, _React$Component);

	function Select() {
		_classCallCheck(this, _Select);

		_React$Component.apply(this, arguments);
	}

	Select.prototype.getError = function getError() {
		return this.props.error && this.props.error[0];
	};

	Select.prototype.renderInputGroup = function renderInputGroup(children) {
		var addonBefore = this.props.addonBefore ? _react2['default'].createElement(
			'span',
			{ className: 'input-group-addon', key: 'addonBefore' },
			this.props.addonBefore
		) : null;

		var addonAfter = this.props.addonAfter ? _react2['default'].createElement(
			'span',
			{ className: 'input-group-addon', key: 'addonAfter' },
			this.props.addonAfter
		) : null;

		var buttonBefore = this.props.buttonBefore ? _react2['default'].createElement(
			'span',
			{ className: 'input-group-btn' },
			this.props.buttonBefore
		) : null;

		var buttonAfter = this.props.buttonAfter ? _react2['default'].createElement(
			'span',
			{ className: 'input-group-btn' },
			this.props.buttonAfter
		) : null;

		var inputGroupClassName = undefined;
		switch (this.props.bsSize) {
			case 'small':
				inputGroupClassName = 'input-group-sm';
				break;
			case 'large':
				inputGroupClassName = 'input-group-lg';
				break;
			default:
		}

		return addonBefore || addonAfter || buttonBefore || buttonAfter ? _react2['default'].createElement(
			'div',
			{ className: _classnames2['default'](inputGroupClassName, 'input-group'), key: 'input-group' },
			addonBefore,
			buttonBefore,
			children,
			addonAfter,
			buttonAfter
		) : children;
	};

	Select.prototype.renderIcon = function renderIcon() {
		if (this.props.hasFeedback) {
			if (this.props.feedbackIcon) {
				return _react2['default'].cloneElement(this.props.feedbackIcon, { formControlFeedback: true });
			}

			switch (this.props.bsStyle) {
				case 'success':
					return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'ok', key: 'icon' });
				case 'warning':
					return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'warning-sign', key: 'icon' });
				case 'error':
					return _react2['default'].createElement(_Glyphicon2['default'], { formControlFeedback: true, glyph: 'remove', key: 'icon' });
				default:
					return _react2['default'].createElement('span', { className: 'form-control-feedback', key: 'icon' });
			}
		} else {
			return null;
		}
	};

	Select.prototype.renderHelp = function renderHelp() {
		return this.props.help ? _react2['default'].createElement(
			'span',
			{ className: 'help-block', key: 'help' },
			this.props.help
		) : null;
	};

	Select.prototype.renderWrapper = function renderWrapper(children) {

		var classes = {
			'has-error': this.getError()
		};
		var style = this.props.style;

		return _react2['default'].createElement(
			'span',
			{ style: style, className: _classnames2['default'](classes, this.props.wrapperClassName), key: 'wrapper' },
			children
		);
	};

	Select.prototype.renderLabel = function renderLabel(children) {
		var classes = {
			'control-label': false
		};
		classes[this.props.labelClassName] = this.props.labelClassName;

		return this.props.label ? _react2['default'].createElement(
			'label',
			{ htmlFor: this.props.id, className: _classnames2['default'](classes), key: 'label' },
			children,
			this.props.label
		) : children;
	};

	Select.prototype.renderInput = function renderInput() {

		var className = '';
		return _react2['default'].createElement(_reactisForms.Select, _extends({}, this.props, { className: _classnames2['default'](this.props.className, className), key: 'input' }));
	};

	Select.prototype.renderError = function renderError() {
		var error = this.getError();
		return error ? _react2['default'].createElement(
			'span',
			{ className: 'error-block', key: 'error' },
			error
		) : null;
	};

	Select.prototype.renderChildren = function renderChildren() {
		return [
		//this.renderLabel(),
		this.renderWrapper([this.renderInputGroup(this.renderInput()), this.renderIcon(), this.renderError()])];
	};

	Select.prototype.render = function render() {
		var children = this.renderChildren();
		return _react2['default'].createElement(
			'span',
			null,
			children
		);
	};

	var _Select = Select;
	Select = _wrapComponent('_$Select')(Select) || Select;
	return Select;
})(_react2['default'].Component);

Select.propTypes = {
	type: _react2['default'].PropTypes.string,
	label: _react2['default'].PropTypes.node,
	help: _react2['default'].PropTypes.node,
	addonBefore: _react2['default'].PropTypes.node,
	addonAfter: _react2['default'].PropTypes.node,
	buttonBefore: _react2['default'].PropTypes.node,
	buttonAfter: _react2['default'].PropTypes.node,
	bsSize: _react2['default'].PropTypes.oneOf(['small', 'medium', 'large']),
	bsStyle: _react2['default'].PropTypes.oneOf(['success', 'warning', 'error']),
	hasFeedback: _react2['default'].PropTypes.bool,
	feedbackIcon: _react2['default'].PropTypes.node,
	id: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
	groupClassName: _react2['default'].PropTypes.string,
	wrapperClassName: _react2['default'].PropTypes.string,
	labelClassName: _react2['default'].PropTypes.string,
	disabled: _react2['default'].PropTypes.bool,
	value: _react2['default'].PropTypes.any
};

Select.defaultProps = {
	type: 'text',
	placeholder: '',
	disabled: false,
	hasFeedback: false
};

exports['default'] = Select;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-inputs/Select.js
 ** module id = 1020
 ** module chunks = 1
 **/